import * as React from 'react';
import { deleteTransfer} from 'shared/src/api/transfers'
import {Menu, MenuItem, Stack, Typography, Box, Button} from '@mui/material';
import {Delete as DeleteIcon, Close as CloseIcon} from '@mui/icons-material';
import EditTransferRequest from './EditTransferRequest';
import { CustomModal, CustomSnackbar, CustomRouterLink } from '../SharedComponents'

const successMessage = "La Solictud de transferencia se ha eliminado correctamen"
const errorMessage = "Ha ocurrido un error, intente más tarde.";

export default function Actions(props) {
  const {
    handleClose,
    anchorEl,
    open,
    selectedTransferId,
    requestTransferListFromService,
    userIDSelected,
  } = props;

  const [actionButtonsDisabled, setActionButtonsDisabled] = React.useState(false);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = React.useState(false);
  const [opeAlert, setOpenAlert] = React.useState(false);
  const [messageForAlert, setMessageForAlert] = React.useState({});
  const [openEditTransferRequest, setOpenEditTransferRequest] = React.useState(false);


  const handleCloseDeleteConfirmation = (e, reason) => {
    if(reason === "backdropClick") return;
    setOpenDeleteConfirmation(false);
  }

  const handOpenDeleteConfirmation = () => {
    setOpenDeleteConfirmation(true);
  }

  const handleDeleteNotification = async (_,selectedTransferId) => {
    setActionButtonsDisabled(true);
    try {
          await deleteTransfer(selectedTransferId);
          setMessageForAlert({message:successMessage,severity:"success" });
    } catch (error) {
       setMessageForAlert({message:errorMessage,severity:"error" });
    }

    setActionButtonsDisabled(false);
    setOpenAlert(true);
    setOpenDeleteConfirmation(false);
    requestTransferListFromService()
  }

  // for small notification
  const handleCloseAlert = (_, reason)=> {
    if (reason === 'clickaway') return;
    setOpenAlert(false);
  }

  return (
    <>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={()=>setOpenEditTransferRequest(true)}
        >
          Cambiar Estado
        </MenuItem>
        <MenuItem><CustomRouterLink to={`/users/${userIDSelected}/detail`}>Ver Usuario</CustomRouterLink></MenuItem>
        <MenuItem onClick={handOpenDeleteConfirmation}>Borrar</MenuItem>
      </Menu>
      {/* to confirm delete notifications*/}
      <CustomModal
        handleClose={handleCloseDeleteConfirmation}
        open={openDeleteConfirmation}
        customStyles={{width:'500px'}}
      >
        <Stack>
            <Typography variant="h7" align="center">¿Seguro que desea Borrar la solicitud de transferencia?</Typography>
            <Box sx={{display:'flex', justifyContent: 'center', mt:2}}>
                <Button
                    onClick={(e)=>handleDeleteNotification(e, selectedTransferId)}
                    disabled={actionButtonsDisabled}
                    startIcon={<DeleteIcon />}
                    variant="contained"
                    color="error"
                    sx={{mr:1}}
                    disableElevation
                >
                    Borrar
                </Button>
                <Button
                    onClick={handleCloseDeleteConfirmation}
                    disabled={actionButtonsDisabled}
                    startIcon={<CloseIcon />}
                    variant="contained"
                    color="success"
                    sx={{ml:1}}
                    disableElevation
                >
                    Cancelar
                </Button>
            </Box>
        </Stack>
      </CustomModal>
      {/* small alert at the bottom left to confirm/deny operation*/}
      <CustomSnackbar opeSnackbar={ opeAlert } messageForAlert={messageForAlert} handleCloseAlert={handleCloseAlert} />
      {/* Para editar las notificaciones*/}
        {openEditTransferRequest && <EditTransferRequest
          requestTransferListFromService = {requestTransferListFromService}
          open = {openEditTransferRequest}
          setOpen = {setOpenEditTransferRequest}
          selectedTransferId = {selectedTransferId}
        />}
    </>
  );
}